import React from 'react';

import { ModalComponent } from 'components';
import { EnrollResponseDataType } from 'types';
import { EnrollQuery, EventFeedbackQuery } from 'queries';
import { getQuestionResponse } from 'utils/question';

interface Props {
  eventId: string;
  data: EnrollResponseDataType | null;
  onClose: () => void;
}

function ViewModal({ eventId, data, onClose }: Props) {
  const { data: res } = EnrollQuery.useGetResponse(
    data?.userId || 1,
    data?.enrollId || 1,
    data !== null,
  );
  const { data: feedback } = EventFeedbackQuery.useGet(eventId);

  const questions = getQuestionResponse(
    feedback?.questions || [],
    res?.feedback || [],
  );

  if (!data || !res) return null;

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal
          title="추가정보"
          handleClose={onClose}
          footer={<></>}
        >
          {res.feedback ? (
            <div>
              {questions?.map(
                (q: { id: number; response: string; title: string }) => (
                  <div
                    key={q.id}
                    css={{ '>p': { lineHeight: '1.4', wordBreak: 'keep-all' } }}
                  >
                    <p css={{ margin: '12px 0', fontWeight: 'bold' }}>
                      {q.title}
                    </p>
                    <p css={{ margin: '12px 0 24px 0' }}>{q.response}</p>
                  </div>
                ),
              )}
            </div>
          ) : (
            <div>
              <p>피드백 제출내용이 없습니다.</p>
            </div>
          )}
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default ViewModal;
